interface IEnvironmentConfig {
    ApiEndpoint: string;
    GoogleAnalyticsKey: string;
    SmartLookKey: string;
}

class DevelopmentEnvironmentConfig implements IEnvironmentConfig {
    ApiEndpoint: string = 'https://localhost:44311/';
    GoogleAnalyticsKey: string = '';
    SmartLookKey: string = '';
}

class SandboxEnvironmentConfig implements IEnvironmentConfig {
    ApiEndpoint: string = 'https://pcsapisbx.paycritical.com/';
    GoogleAnalyticsKey: string = '';
    SmartLookKey: string = '';

}

class ProductionEnvironmentConfig implements IEnvironmentConfig {
    ApiEndpoint: string = 'https://pcsapi.paycritical.com/';
    GoogleAnalyticsKey: string = 'G-5RZGJKHPHZ';
    SmartLookKey: string = 'e5a15cb2ac7e2956a1b753669d8dabfc46325e6e';

}

export const getEnvironmentConfiguration = (): IEnvironmentConfig => {
    switch (process.env.REACT_APP_ENV) {
        case 'production':
            return new ProductionEnvironmentConfig();
        case 'sandbox':
            return new SandboxEnvironmentConfig();
        default:
            break;
    }

    return new DevelopmentEnvironmentConfig();
}